// import React, { useState } from 'react';
 

// import Marquee from 'react-fast-marquee';

// import { Pane,toaster, Paragraph,TextInputField,TextareaField, IconButton, Text, Button,Heading,Card,Icon,   majorScale, Image,} from 'evergreen-ui';
// import { ChevronDownIcon, ChevronUpIcon } from 'evergreen-ui';

// import { DotLottieReact } from '@lottiefiles/dotlottie-react';
// import animationData from '../assets/anime.json'; // Adjust the path as necessary
// import Lottie from 'lottie-react';

// import FirestoreService from '../appservices/AppManager'; // Import FirestoreService

// import PricingPage from './Pricing';
 
// // Import local logo images
// import amznLogo from '../assets/logos/amzn.png';
// // import ebayLogo from '../assets/logos/ebay.png'; // Replace with the actual path if different
// import shopifyLogo from '../assets/logos/shopify.png'; // Replace with the actual path if different
// import walmartLogo from '../assets/logos/walmart.png'; // Replace with the actual path if different
// import heroImage from '../assets/train.png'; // adjust path if needed

// const firestoreService = new FirestoreService('contactMessages'); // Specify Firestore collection for messages


// const logos = [
//   { src: amznLogo, alt: 'Amazon' },
//   // { src: ebayLogo, alt: 'Ebay' },
//   { src: shopifyLogo, alt: 'Shopify' },
//   { src: walmartLogo, alt: 'Walmart' },
//   // Add more logos as needed
// ];

 
 
 





 
// const faqs = [
//   {
//     question: "How do I get started?",
//     answer: "Getting started is easy! Share your email in the input box above to schedule a demo and explore how our AI-driven product support can enhance your customer experience.",
//   },
//   {
//     question: "What industries and products do you support?",
//     answer: "We specialize in providing AI product support for electronics, including consumer devices, appliances, and other tech products. Our solution is adaptable to manufacturers and retailers across various sectors.",
//   },
//   {
//     question: "How does the AI agent help customers?",
//     answer: "Our AI agent is trained to understand product specifications, troubleshoot issues, and provide step-by-step guidance to customers. It ensures fast and effective problem resolution, reducing the need for manual support.",
//   },
//   {
//     question: "How much does it cost?",
//     answer: "We offer flexible tiered pricing to fit the needs of manufacturers and retailers of all sizes. Schedule a free demo with us to get a personalized quote tailored to your requirements!",
//   },
//   {
//     question: "Is the AI customizable for my products?",
//     answer: "Absolutely! Our AI can be customized to understand your product catalog, FAQs, and specific troubleshooting workflows, ensuring a seamless customer experience that matches your brand's expertise.",
//   },
// ];

 


 

// function FeatureSection() {
//   return (
//     <Pane
//       id="features"
//       display="flex"
//       flexDirection="column"
//       alignItems="center"
//       paddingX={32}
//       paddingY={64}
//       background="tint2"
//     >
//       {/* Heading Content */}
//       <Pane display="flex" flexDirection="column" alignItems="center" textAlign="center" maxWidth={800}>
//         <Heading size={900} marginBottom={24}>
//           Join sellers automating product support with Konstant
//         </Heading>
//         {/* Button Row */}
//         <Pane display="flex" marginTop={16}>
//           <Button appearance="primary" height={48}>
//             Get started
//           </Button>
//         </Pane>
//       </Pane>

//       {/* Ticker Wrap */}
//       <Pane marginTop={48} width="100%" background="tint1" paddingY={24}>
//         <Marquee gradient={false} speed={40}>
//           {logos.map((logo, index) => (
//             <Pane key={index} marginX={32} display="flex" alignItems="center" justifyContent="center">
//               <Image
//                 src={logo.src}
//                 alt={logo.alt}
//                 width={120}
//                 height="auto"
//                 objectFit="contain"
//                 style={{ maxHeight: 60, padding: 8 }}
//               />
//             </Pane>
//           ))}
//         </Marquee>
//       </Pane>
//     </Pane>
//   );
// }

// function FAQSection() {
//   const [openIndex, setOpenIndex] = useState(null);

//   const toggleFAQ = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   return (
//     <Pane id="faqs" display="flex" flexDirection="column" alignItems="center" paddingX={24} paddingY={48}>
//       <Heading size={900} marginBottom={40} textAlign="center">
//         Frequently Asked Questions
//       </Heading>

//       <Pane display="flex" flexDirection="column" gap={20} width="100%" maxWidth={720}>
//         {faqs.map((faq, index) => (
//           <Pane
//             key={index}
//             background="white"
//             borderRadius={8}
//             padding={20}
//             border="muted"
//             boxShadow="0px 4px 8px rgba(0, 0, 0, 0.05)"
//             cursor="pointer"
//             transition="all 0.3s ease-in-out"
//             onClick={() => toggleFAQ(index)}
//           >
//             <Pane display="flex" alignItems="center" justifyContent="space-between">
//               <Text size={600} fontWeight={600} color="dark">
//                 {faq.question}
//               </Text>
//               <IconButton icon={openIndex === index ? ChevronUpIcon : ChevronDownIcon} appearance="minimal" marginLeft={8} />
//             </Pane>
//             {openIndex === index && (
//               <Paragraph marginTop={12} paddingLeft={8} paddingRight={8} color="muted" lineHeight="1.5" transition="opacity 0.3s ease-in-out">
//                 {faq.answer}
//               </Paragraph>
//             )}
//           </Pane>
//         ))}
//       </Pane>

//       {/* Contact Link */}
//       <Paragraph marginTop={40} size={400} textAlign="center">
//         Can’t find what you’re looking for?{' '}
//         <Button appearance="link" href="#demo">
//           Get in touch
//         </Button>
//       </Paragraph>
//     </Pane>
//   );
// }


// // import React, { useState } from 'react';
// // import { Pane, Heading, Paragraph, TextInputField, TextareaField, Button, Card } from 'evergreen-ui';
// // import FirestoreService from '../appservices/AppManager'; // Import FirestoreService

// // const firestoreService = new FirestoreService('contactMessages'); // Specify Firestore collection for messages

// function ContactUs() {
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [phone, setPhone] = useState('');
//   const [message, setMessage] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [confirmationMessage, setConfirmationMessage] = useState('');

//   const handleSubmit = async () => {
//     if (!name || !email || !phone || !message) {
//       setConfirmationMessage('All fields are required.');
//       return;
//     }

//     setLoading(true);
//     setConfirmationMessage('');
//     try {
//       const data = {
//         name,
//         email,
//         phone,
//         message,
//         timestamp: new Date().toISOString(),
//       };

//       // Save message to Firestore
//       await firestoreService.createOrUpdateDocument(null, data);

//       setConfirmationMessage('Thank you! Your message has been sent successfully. We will get back to you shortly.');
//       setName('');
//       setEmail('');
//       setPhone('');
//       setMessage('');
//     } catch (error) {
//       console.error('Error submitting contact form:', error);
//       setConfirmationMessage('Failed to send message. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Pane id="contact" display="flex" flexDirection="column" alignItems="center" padding={48} background="tint1" gap={32}>
//       {/* Heading Section */}
//       <Pane display="flex" flexDirection="column" alignItems="center" marginBottom={32}>
//         <Heading size={900} marginBottom={8} textAlign="center">
//           Interested? Reach out!
//         </Heading>
//         <Paragraph size={500} textAlign="center">
//           Have a specific question? We're always here to help.
//         </Paragraph>
//       </Pane>

//       <Pane display="flex" width="100%" maxWidth={1200} justifyContent="space-between" gap={32}>
//         {/* Left Section - Form */}
//         <Pane flex={2} padding={24} background="white" borderRadius={12} elevation={1}>
//           <TextInputField
//             label="Name"
//             placeholder="Enter your name"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             marginBottom={24}
//           />
//           <TextInputField
//             label="Email"
//             placeholder="Enter your email"
//             type="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             marginBottom={24}
//           />
//           <TextInputField
//             label="Phone Number"
//             placeholder="Enter your phone number"
//             value={phone}
//             onChange={(e) => setPhone(e.target.value)}
//             marginBottom={24}
//           />
//           <TextareaField
//             label="Message"
//             placeholder="Enter your message"
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//             marginBottom={24}
//             height={200}
//           />

//           {confirmationMessage && (
//             <Paragraph marginBottom={16} color={confirmationMessage.includes('Thank you') ? 'green' : 'red'}>
//               {confirmationMessage}
//             </Paragraph>
//           )}

//           <Button
//             appearance="primary"
//             height={48}
//             width="100%"
//             marginTop={16}
//             onClick={handleSubmit}
//             isLoading={loading}
//           >
//             Submit
//           </Button>
//         </Pane>

//         {/* Right Section - Contact Methods */}
//         <Pane display="flex" flexDirection="column" flex={1} gap={16}>
//           <Card background="white" elevation={1} padding={24} borderRadius={12} display="flex" alignItems="center">
//             <Pane>
//               <Heading size={600} marginBottom={4}>
//                 Email us
//               </Heading>
//               <Paragraph size={400} marginBottom={4}>
//                 ~2 hour average response time
//               </Paragraph>
//               <Paragraph size={400}>enoch@konstantai.com</Paragraph>
//             </Pane>
//           </Card>
//         </Pane>
//       </Pane>
//     </Pane>
//   );
// }

 

 
//  function Homepage() {
//   return (
//     <>
//       {/* ░░ Hero ░░ */}
//       <Pane
//         height="85vh"
//         width="100vw"
//         background={`linear-gradient(to right, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0) 70%), url(${heroImage}) center/cover no-repeat`}
//         display="flex"
//         flexDirection="column"
//         justifyContent="center"
//         paddingX={majorScale(8)}
//       >
//         <Heading
//           size={900}
//           color="white"
//           maxWidth="600px"
//           lineHeight="1.2"
//           marginBottom={majorScale(2)}
//         >
//           Always-On&nbsp;AI for Railroads&nbsp;and&nbsp;Critical Infrastructure
//         </Heading>

//         <Paragraph
//           size={500}
//           color="rgba(255,255,255,0.9)"
//           maxWidth="520px"
//           marginBottom={majorScale(3)}
//         >
//           Konstant deploys real-time AI agents that detect and resolve
//           infrastructure failures—before they become fines, outages, or
//           accidents.
//         </Paragraph>

//         <Button
//           appearance="primary"
//           height={48}
//           width={220}
//           marginTop={majorScale(1)}
//         >
//           Book a Demo
//         </Button>
//       </Pane>

//       {/* ░░ Body content ░░ */}
//       <Pane
//         id="home"
//         background="tint2"
//         paddingX={majorScale(6)}
//         paddingY={majorScale(8)}
//       >
//         <FAQSection />
//         <ContactUs />
//       </Pane>
//     </>
//   );
// }



// export default Homepage;


// PATH: Iris/iris-web/src/views/Homepage.js
// Konstant homepage with smooth scroll "Book a Demo" -> contact form, form transitions to thank‑you.

import React, { useState, useRef } from 'react';
import {
  Pane,
  Heading,
  Paragraph,
  Button,
  Image,
  IconButton,
  TextInputField,
  TextareaField,
  Text,
  Card,
  majorScale,
} from 'evergreen-ui';
import { ChevronDownIcon, ChevronUpIcon } from 'evergreen-ui';
import Marquee from 'react-fast-marquee';

import heroImage from '../assets/train.png';
import amznLogo from '../assets/logos/amzn.png';
import shopifyLogo from '../assets/logos/shopify.png';
import walmartLogo from '../assets/logos/walmart.png';

import FirestoreService from '../appservices/AppManager';
const firestore = new FirestoreService('contactMessages');

/* ─────────────────────────────────────────────────────────── */
/*  Static assets                                             */
/* ─────────────────────────────────────────────────────────── */
const logos = [
  { src: amznLogo, alt: 'Amazon' },
  { src: shopifyLogo, alt: 'Shopify' },
  { src: walmartLogo, alt: 'Walmart' },
];

const faqs = [
  { q: 'How do I get started?', a: 'Share your email in the form below and we will schedule a demo of Konstant’s AI‑powered monitoring in action.' },
  { q: 'Which industries do you cover?', a: 'Railroads, highways, energy and other critical infrastructure where downtime or accidents carry real‑world costs.' },
  { q: 'Is Konstant hardware or software?', a: 'Both. Our edge agents run on off‑the‑shelf IP cameras or existing NVRs, while the AI brain lives in the cloud for fleet‑wide insights.' },
  { q: 'How does pricing work?', a: 'Simple per‑camera monthly pricing with volume discounts. Contact us for a tailored quote.' },
];

/* ─────────────────────────────────────────────────────────── */
/*  Customers marquee                                          */
/* ─────────────────────────────────────────────────────────── */
function CustomersMarquee() {
  return (
    <Pane width="100%" background="tint1" paddingY={majorScale(3)}>
      <Marquee gradient={false} speed={35} pauseOnHover>
        {logos.map((l, idx) => (
          <Pane key={idx} marginX={majorScale(4)}>
            <Image src={l.src} alt={l.alt} height={60} objectFit="contain" opacity={0.8} />
          </Pane>
        ))}
      </Marquee>
    </Pane>
  );
}

/* ─────────────────────────────────────────────────────────── */
/*  FAQ accordion                                              */
/* ─────────────────────────────────────────────────────────── */
function FAQSection() {
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <Pane id="faq" paddingY={majorScale(8)} display="flex" flexDirection="column" alignItems="center">
      <Heading size={900} marginBottom={majorScale(5)} textAlign="center">
        Frequently Asked Questions
      </Heading>
      <Pane width="100%" maxWidth={720} display="flex" flexDirection="column" gap={majorScale(3)}>
        {faqs.map((f, idx) => (
          <Pane
            key={idx}
            background="white"
            padding={majorScale(3)}
            borderRadius={8}
            elevation={1}
            onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
            cursor="pointer"
          >
            <Pane display="flex" alignItems="center" justifyContent="space-between">
              <Text size={600}>{f.q}</Text>
              <IconButton icon={openIdx === idx ? ChevronUpIcon : ChevronDownIcon} appearance="minimal" />
            </Pane>
            {openIdx === idx && (
              <Paragraph marginTop={majorScale(2)} size={400} color="muted">
                {f.a}
              </Paragraph>
            )}
          </Pane>
        ))}
      </Pane>
    </Pane>
  );
}

/* ─────────────────────────────────────────────────────────── */
/*  Contact / Demo form                                        */
/* ─────────────────────────────────────────────────────────── */
function ContactUs({ forwardedRef }) {
  const [form, setForm]   = useState({ name: '', email: '', message: '' });
  const [busy, setBusy]   = useState(false);
  const [done, setDone]   = useState(false);
  const [error, setError] = useState('');

  const handle = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.message) {
      setError('Please complete all fields.');
      return;
    }
    setBusy(true);
    setError('');

    try {
      await firestore.createOrUpdateDocument(null, { ...form, ts: Date.now() });
      setDone(true);
    } catch (err) {
      console.error(err);
      setError('Failed to send. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Pane ref={forwardedRef} id="contact" background="tint1" paddingY={majorScale(8)} display="flex" justifyContent="center">
      <Pane width="100%" maxWidth={900} background="white" padding={majorScale(4)} borderRadius={12} elevation={1}>
        {done ? (
          <Pane display="flex" flexDirection="column" alignItems="center" gap={majorScale(3)}>
            <Heading size={800}>Thank you!</Heading>
            <Paragraph size={500} maxWidth={560} textAlign="center">
              Your message has been received. A Konstant team member will contact you soon.
            </Paragraph>
          </Pane>
        ) : (
          <>
            <Heading size={800} marginBottom={majorScale(4)}>Book a Demo</Heading>
            <TextInputField label="Name"    placeholder="Jane Rail"       value={form.name}    onChange={handle('name')} />
            <TextInputField label="Email"   placeholder="jane@railco.com" value={form.email}   onChange={handle('email')} />
            <TextareaField   label="Message" value={form.message} onChange={handle('message')} height={120} />
            {error && (
              <Paragraph size={400} marginBottom={majorScale(2)} color="red">
                {error}
              </Paragraph>
            )}
            <Button appearance="primary" height={48} width={200} onClick={handleSubmit} isLoading={busy}>
              Send Message
            </Button>
          </>
        )}
      </Pane>
    </Pane>
  );
}

/* ─────────────────────────────────────────────────────────── */
/*  Main homepage component                                    */
/* ─────────────────────────────────────────────────────────── */
export default function Homepage() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Hero */}
      <Pane
        height="90vh"
        width="100vw"
        background={`linear-gradient(to right, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 35%, rgba(0,0,0,0) 70%), url(${heroImage}) center/cover no-repeat`}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        paddingX={majorScale(8)}
      >
        <Heading size={900} color="white" maxWidth={640} lineHeight="1.15" marginBottom={majorScale(2)}>
          Always‑On AI for Railroads
        </Heading>
        <Paragraph size={500} color="rgba(255,255,255,0.9)" maxWidth={520} marginBottom={majorScale(4)}>
          Konstant detects and resolves infrastructure failures—before they become fines, outages, or accidents.
        </Paragraph>
        <Button appearance="primary" height={48} width={220} onClick={scrollToContact}>
          Book a Demo
        </Button>
      </Pane>

      {/* Customers marquee */}
      <CustomersMarquee />

      {/* FAQ */}
      <FAQSection />

      {/* Contact */}
      <ContactUs forwardedRef={contactRef} />
    </>
  );
}
